import _ from 'lodash';
import ModelType from '../../Model/ModelType';
import PropertyFunction from './util/PropertyFunction';
import { PlotlineTypes } from 'utils/types';
import T from 'localization/LocalizationKeys';
import NodeDataSource from './NodeDataSource';
import useMeasurementSystem from 'components/Value/useMeasurementSystem';


const PlotLine = (plotline, displayName, value) => {
  return {
    ..._.pick(plotline, ['color', 'lineStyle', 'width']),
    displayName: (plotline?.noDisplayName) ? '' : displayName,
    name: plotline.name,
    value: value
  };
};

const PlotlineDataSource =
  ({
    nodes: nodesFromDatasource,
    plotlines = {}
  }) => {
    const groupedPlotlines = _.reduce(plotlines?.lines, (acc, plotline) => {
      const plotType = plotline.plotType;
      if (!acc[plotType]) {
        acc[plotType] = [];
      }
      acc[plotType].push(plotline);
      return acc;
    }, {});

    const propertyPlotlines = _.compact(_.concat(groupedPlotlines[PlotlineTypes.ReportedProperty], groupedPlotlines[PlotlineTypes.DesiredProperty])) || [];
    const staticPlotlines = groupedPlotlines[PlotlineTypes.StaticValue] || [];
    const updatedPlotlines = [];

    const properties = _.flatten(_.map(propertyPlotlines, plotline => {
      return plotline.propertyValue;
    }));

    const { convertToUserValue } = useMeasurementSystem();

    const { assetModel, isLoading } =
        PropertyFunction({ nodes: nodesFromDatasource, properties });

    const isLoadingPlotlines = isLoading;
    _.forEach(propertyPlotlines, (plotline) => {
      const chosenPlotlineProperty = _.first(_.filter(plotline.propertyValue, { modelId: assetModel.id }));
      const property = _.find([...(assetModel.properties ?? []), ...(assetModel.metaProperties ?? [])], { name: chosenPlotlineProperty?.name });
      if (property) {
        if (plotline.plotType === PlotlineTypes.ReportedProperty) {
          const reported = convertToUserValue({ value: property.reported, schemaUnit: property });
          updatedPlotlines.push(
            PlotLine(plotline, property.displayName, reported)
          );
        } else if (plotline.plotType === PlotlineTypes.DesiredProperty) {
          const desired = convertToUserValue({ value: property.desired, schemaUnit: property });
          updatedPlotlines.push(
            PlotLine(plotline, property.displayName, desired)
          );
        }
      }
    });

    if (!_.isEmpty(staticPlotlines)) {
      _.forEach(staticPlotlines, (plotline) => {
        updatedPlotlines.push(
          PlotLine({ ...plotline, name: 'static' }, plotline.displayName, plotline.staticValue)
        );
      });
    }
    return { plotlines: updatedPlotlines, isLoadingPlotlines };
  };

PlotlineDataSource.models = [
  ...NodeDataSource.models,
  {
    path: 'plotlines',
    type: ModelType.PLOTLINES_MODAL,
    label: T.common.plotlines
  }
];

const getPlotLineModels = (plotlines) => {
  const plotlineModels = _.reduce(plotlines, (result, plotline) => {
    switch (plotline.plotType) {
      case PlotlineTypes.ReportedProperty:
      case PlotlineTypes.DesiredProperty:
        if (plotline.propertyValue?.[0].modelId) {
          return [...result, plotline.propertyValue[0].modelId];
        }
        return result;
      case PlotlineTypes.StaticValue:
      default:
        return result;
    }
  }, []);
  return plotlineModels;
};

PlotlineDataSource.getUsedSystemModels = (data) => {
  return getPlotLineModels(data?.plotlines?.lines) ?? [];
};

export default PlotlineDataSource;
